import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';

const Root = styled('div')(({ theme }) => ({
  '& .username, & .email': {
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
}));

const handleValidateImage = (image, host) => {
  if (!image) return undefined;

  const path = image.fullPathThumb || image.fullPath;
  if (!path) return undefined;

  const normalizedHost = host ?? '';
  const separator = host ? '/' : '';
  return `${normalizedHost}${separator}${path}`;
};

function UserNavbarHeader(props) {
  const profile = useSelector((state) => state.profile);
  const { config } = useSelector((state) => state.config);
  const { host } = config.api;
  const { avatar, name, email, backgroundColor } = profile;

  return (
    <Root className="user relative flex flex-col items-center justify-center p-16 pb-14 shadow-0">
      <div className="flex flex-auto items-center justify-center mb-24 w-full h-full">
        {profile !== undefined && (
          <Avatar
            sx={{
              aspectRatio: 1 / 1,
              width: '18rem',
              height: 'auto',
              backgroundColor,
            }}
            className="avatar md:mx-4"
            alt={name}
            src={handleValidateImage(avatar, host)}
          >
            <p style={{ fontSize: '3.2em', fontWeight: 'normal', color: '#FFF' }}>
              {typeof name === 'string' &&
                name
                  .split(' ')
                  .map((word) => word[0])
                  .join('')
                  .substring(0, 2)
                  .toUpperCase()}
            </p>
          </Avatar>
        )}
      </div>
      <Typography className="username text-14 line-clamp-1 leading-tight text-ellipsis font-medium py-4">
        {name}
      </Typography>
      <Typography className="email text-13 line-clamp-1 font-medium" color="text.secondary">
        {email}
      </Typography>
    </Root>
  );
}

export default UserNavbarHeader;
